import {
  CollectionName,
  CollectionVisibility,
} from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const ocaUsersSchema: CollectionCreateSchema = {
  name: CollectionName.OcaUsers,
  fields: [
    {
      name: "id",
      type: "string",
      infix: true,
    },
    {
      name: "subId",
      type: "string",
      facet: true,
      infix: true,
    },
    {
      name: "systemUsername",
      type: "string",
      optional: true,
      infix: true,
    },
    {
      name: "fullName",
      type: "string",
      infix: true,
      optional:true,
      sort: true,
    },
    {
      name: "email",
      type: "string",
      optional: true,
      infix: true,
    },
    {
      name: "accountType",
      type: "string",
      facet: true,
      infix: true,
    },
    {
      name: "status",
      type: "string",
      facet: true,
      infix: true,
    },
    {
      name: "jobTitle",
      type: "string",
      optional: true,
      infix: true,
    },
    {
      name: "contactNumber",
      type: "string",
      optional: true,
      infix: true,
    },
    {
      name: "certificateTypes",
      type: "string[]",
      optional: true,
      facet: true,
    },
    {
      name: "countries",
      type: "string[]",
      optional: true,
      facet: true,
    },
    {
      name: "inspectionPorts",
      type: "string[]",
      optional: true,
      facet: true,
    },
    {
      name: "agencyId",
      type: "string",
      optional: true,
      facet: true,
      infix: true,
    },
    {
      name: "agencyName",
      type: "string",
      optional: true,
      infix: true,
    },
    {
      name: "profileName",
      type: "string",
      optional: true,
      infix: true,
    },
    {
      name: "reason",
      type: "string",
      optional: true,
      infix: true,
    },
    {
      name: "comment",
      type: "string",
      optional: true,
      infix: true,
    },
    {
      name: "createdAt",
      type: "int64",
      optional: true,
      infix: true
    },
    {
      name: "updatedAt",
      type: "int64",
      optional: true,
      infix: true,
    },
    {
      name: "createdBy",
      type: "string",
      optional: true,
      infix: true,
    },
    {
      name: "updatedBy",
      type: "string",
      optional: true,
      infix: true,
    },
  ],
  default_sorting_field: "",
  visibility: CollectionVisibility.Private,
}
